module.exports = __webpack_public_path__ + "img/add.8ba39959.svg";